module.exports = __webpack_public_path__ + "static/media/banana.637ae67d.gif";